import { Component } from '@angular/core';

@Component({
  selector: 'ut-error-icon',
  templateUrl: './error-icon.component.html',
  styleUrls: ['./error-icon.component.scss'],
  standalone: false,
})
export class UnifiedErrorIconComponent {
}
